import { Controller } from "@hotwired/stimulus"

// 同一カテゴリー内のマスター（施術・物販）の表示順を
// HTML5 ネイティブ Drag & Drop で並び替えるコントローラ。
// 依存ライブラリなし。
//
// 使い方:
//   <tbody data-controller="sortable"
//          data-sortable-url-value="/ja/shops/28/services/reorder"
//          data-sortable-category-value="123">
//     <tr draggable="true" data-sortable-target="item" data-master-id="1">...</tr>
//     ...
//   </tbody>
export default class extends Controller {
  static values = { url: String, category: String }
  static targets = ["item"]

  connect() {
    this.dragging = null
    this.itemTargets.forEach((row) => this.bindRow(row))
  }

  bindRow(row) {
    row.addEventListener("dragstart", (e) => this.onDragStart(e, row))
    row.addEventListener("dragend", (e) => this.onDragEnd(e, row))
    row.addEventListener("dragover", (e) => this.onDragOver(e, row))
    row.addEventListener("drop", (e) => this.onDrop(e, row))
  }

  onDragStart(event, row) {
    this.dragging = row
    // クリック遷移（onclick）と誤認させないためのフラグ
    row.dataset.dragging = "true"
    row.classList.add("sortable-ghost")
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "move"
      // Firefox はデータ設定がないと dragstart が成立しない
      event.dataTransfer.setData("text/plain", row.dataset.masterId || "")
    }
  }

  onDragEnd(event, row) {
    row.classList.remove("sortable-ghost")
    this.itemTargets.forEach((r) => r.classList.remove("sortable-drag-over"))
    this.dragging = null
    // クリック遷移の抑止フラグはわずかに遅らせて解除（drop直後のclick誤発火を防ぐ）
    setTimeout(() => { delete row.dataset.dragging }, 50)
  }

  onDragOver(event, row) {
    if (!this.dragging || this.dragging === row) return
    event.preventDefault()
    if (event.dataTransfer) event.dataTransfer.dropEffect = "move"

    const rect = row.getBoundingClientRect()
    const isAfter = (event.clientY - rect.top) > rect.height / 2
    const parent = row.parentNode

    if (isAfter) {
      parent.insertBefore(this.dragging, row.nextSibling)
    } else {
      parent.insertBefore(this.dragging, row)
    }
  }

  onDrop(event, row) {
    event.preventDefault()
    this.persist()
  }

  persist() {
    const orderedIds = this.itemTargets.map((r) => r.dataset.masterId)
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    const body = new URLSearchParams()
    body.append("category_id", this.categoryValue)
    orderedIds.forEach((id) => body.append("ordered_ids[]", id))

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": token || "",
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "application/json"
      },
      body: body.toString(),
      credentials: "same-origin"
    }).catch((err) => console.error("並び替えの保存に失敗しました", err))
  }
}
